import React from "react";
import { MDBSpinner } from "mdb-react-ui-kit";

import './LoadingSpinner.css';

export class LoadingSpinner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        isLoading: props.isLoading,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isLoading !== prevProps.isLoading) {
      this.setState({ isLoading: this.props.isLoading });
    }
  }

  render() {
    return (
      <div>
        {this.state.isLoading ? (
          <div className="spinner-overlay">
            <div className="spinner">
              <MDBSpinner role="status" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
